import script from "./CreateFarmDap.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateFarmDap.vue?vue&type=script&setup=true&lang=js"

import "./CreateFarmDap.vue?vue&type=style&index=0&id=1cb08a6c&lang=scss"

const __exports__ = script;

export default __exports__